const HEARTBEAT_KEY = 'a1.recordingHeartbeat';
const LEGACY_FLAG_KEY = 'isRecording';

const HEARTBEAT_INTERVAL_MS = 15_000;
const STALE_AFTER_MS = 60_000;

let timer: ReturnType<typeof setInterval> | null = null;

const write = (): void => {
  try {
    localStorage.setItem(HEARTBEAT_KEY, String(Date.now()));
  } catch {
    // Safari private mode throws on localStorage access.
  }
};

const erase = (): void => {
  try {
    localStorage.removeItem(HEARTBEAT_KEY);
  } catch {
    // Safari private mode throws on localStorage access.
  }
};

// The key this replaces was a sticky boolean with no unmount cleanup, so a crash mid-recording
// disabled inactivity auto-logout permanently for that profile. Clear it once so those recover.
try {
  localStorage.removeItem(LEGACY_FLAG_KEY);
} catch {
  // Safari private mode throws on localStorage access.
}

/**
 * Suppresses inactivity auto-logout while a recording is running. A heartbeat rather than a flag,
 * so a process death expires on its own instead of wedging logout forever.
 */
export const startRecordingActivity = (): void => {
  if (timer) return;
  write();
  timer = setInterval(write, HEARTBEAT_INTERVAL_MS);
};

export const stopRecordingActivity = (): void => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
  erase();
};

export const isRecordingActive = (): boolean => {
  try {
    const raw = localStorage.getItem(HEARTBEAT_KEY);
    if (!raw) return false;

    const beatAt = Number(raw);
    return Number.isFinite(beatAt) && Date.now() - beatAt < STALE_AFTER_MS;
  } catch {
    return false;
  }
};
